(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-approved-reviews"]) return;
  try {
    
if (!customElements.get('jb-review-carousel')) {
  customElements.define('jb-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('figure')];
      this.index = 0;
      const refreshRatings = () => {
        document.querySelectorAll('[data-jb-product-rating]').forEach(link => {
          const normalise = text => (text || '').normalize('NFKC').trim().replace(/[’']/g, '').replace(/\s+/g, ' ').toLocaleLowerCase('en-GB').replace('philodendron gloriosum snow leopard', 'philodendron snow leopard');
          const matching = [...this.querySelectorAll('figure')].filter(slide => {
            const linked = slide.dataset.reviewProduct
              ? slide.dataset.reviewProduct === link.dataset.jbProductRating
              : normalise(slide.dataset.reviewPlant) !== '' && normalise(slide.dataset.reviewPlant) === normalise(link.dataset.jbProductName);
            return linked && Number(slide.dataset.reviewRating) >= 1 && Number(slide.dataset.reviewRating) <= 5;
          });
          const number = matching.length;
          if (!number) return;
          const average = matching.reduce((total, slide) => total + Number(slide.dataset.reviewRating), 0) / number;
          link.querySelector('.jb-price-rating__stars').hidden = false;
          link.querySelector('.jb-price-rating__stars > span').style.width = (average / 5 * 100) + '%';
          const summary = link.dataset.label;
          const text = summary.replace('[rating]', average.toFixed(1)).replace('[count]', number);
          const label = link.querySelector('[data-rating-text]');
          if (label.textContent !== text) label.textContent = text;
          if (!link.dataset.ratingBound) {
            link.dataset.ratingBound = 'true';
            link.addEventListener('click', () => {
              const first = this.slides.indexOf(matching[0]);
              if (first >= 0 && this.slides.length > 1) this.move(first - this.index);
              this.paused = true;
              if (this.pauseButton) this.updatePause();
            });
          }
        });
      };
      refreshRatings();
      if (!this.observer) {
        this.observer = new MutationObserver(refreshRatings);
        this.observer.observe(document.querySelector('main'), {childList: true, subtree: true});
      }
      this.slides = [...this.querySelectorAll('figure')];
      if (this.slides.length < 2 || this.ready) return;
      this.ready = true;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseLabel = this.pauseButton.dataset.pauseLabel;
      this.updatePause();
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); });
      this.addEventListener('focusin', event => {
        if (event.target === this.pauseButton) return;
        this.paused = true;
        this.updatePause();
      });
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 6500);
    }
    move(step) {
      this.slides[this.index].hidden = true;
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseLabel;
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.observer = null; this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-customer-feedback"] && !Shopify.designMode) return;
  try {
    
function openReviewFeedback() {
  if (window.location.hash === '#CustomerFeedback') {
    const details = document.querySelector('#CustomerFeedback details');
    if (details) details.open = true;
  }
}
window.addEventListener('hashchange', openReviewFeedback);
openReviewFeedback();
function initReviewProductPickers() {
  document.querySelectorAll('[data-product-picker]').forEach(picker => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = 'true';
    const input = picker.querySelector('[role="combobox"]');
    const list = picker.querySelector('[role="listbox"]');
    const id = picker.querySelector('[data-product-id]');
    const url = picker.querySelector('[data-product-url]');
    const empty = picker.querySelector('[data-product-empty]');
    const normalise = text => text.toLocaleLowerCase().normalize('NFKD').replace(/[’']/g, '').trim();
    let products = Array.from(picker.querySelectorAll('option'), option => ({ id: option.value, title: option.textContent, url: option.dataset.url }));
    let matches = [], active = -1, loading;
    const close = () => { list.hidden = true; empty.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); };
    const validate = () => {
      const item = products.find(item => normalise(item.title) === normalise(input.value));
      id.value = item ? item.id : '';
      url.value = item ? item.url : '';
      input.setCustomValidity(item ? '' : picker.dataset.invalid);
    };
    const choose = item => { input.value = item.title; validate(); close(); input.focus(); };
    const render = (showAll = false) => {
      const words = normalise(showAll ? '' : input.value).split(/\s+/).filter(Boolean);
      matches = products.filter(item => words.every(word => normalise(item.title).includes(word))).sort((a,b) => a.title.localeCompare(b.title));
      active = -1;
      input.removeAttribute('aria-activedescendant');
      list.replaceChildren();
      matches.forEach((item, index) => {
        const option = document.createElement('li');
        option.id = list.id + '-' + index;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.textContent = item.title;
        option.addEventListener('pointerdown', event => { event.preventDefault(); choose(item); });
        list.append(option);
      });
      list.hidden = !matches.length;
      empty.hidden = !!matches.length;
      input.setAttribute('aria-expanded', String(!!matches.length));
    };
    const loadMore = () => {
      if (loading) return loading;
      loading = (async () => {
        let next = picker.querySelector('[data-product-next]')?.href;
        if (!next) return;
        while (next) {
          const endpoint = new URL(next, location.origin);
          endpoint.searchParams.set('section_id', picker.dataset.sectionId);
          const response = await fetch(endpoint, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product list unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          products.push(...Array.from(html.querySelectorAll('[data-product-catalog] option'), option => ({id: option.value, title: option.textContent, url: option.dataset.url})));
          products = [...new Map(products.map(item => [item.id, item])).values()];
          next = html.querySelector('[data-product-next]')?.getAttribute('href');
        }
        if (document.activeElement === input) render();
      })().catch(() => { loading = undefined; });
      return loading;
    };
    input.addEventListener('focus', () => { input.select(); render(true); loadMore(); });
    input.addEventListener('input', () => { validate(); render(); });
    input.addEventListener('blur', () => { validate(); close(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'Enter' && !list.hidden && active >= 0) { event.preventDefault(); choose(matches[active]); return; }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      if (list.hidden) render();
      if (!matches.length) return;
      active = (active + (event.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length;
      Array.from(list.children).forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
      const option = list.children[active];
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    });
    picker.closest('form').addEventListener('submit', event => { validate(); if (!input.checkValidity()) { event.preventDefault(); input.reportValidity(); } });
    validate();
  });
}
initReviewProductPickers();
document.addEventListener('shopify:section:load', initReviewProductPickers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-signup-popup"]) return;
  try {
    
  if (!customElements.get('jb-signup-popup')) {
    customElements.define('jb-signup-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.storageKey = 'jb-signup-popup-v1';
        this.success = Boolean(this.querySelector('[data-success]'));
        this.previousFocus = null;
        this.onLoad = () => {
          this.timer = setTimeout(() => this.attemptOpen(), Number(this.dataset.delay) * 1000);
        };
        this.onClose = () => {
          this.remember(this.success ? 'subscribed' : 'dismissed');
          this.previousFocus?.focus();
        };
        this.dialog.addEventListener('close', this.onClose);
        for (const button of this.querySelectorAll('[data-close]')) button.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        if (this.success || this.querySelector('[data-errors]')) {
          if (this.success) this.remember('subscribed');
          this.open();
          return;
        }
        if (this.hasAttribute('data-editor') || this.hasAttribute('data-subscribed') || this.suppressed()) return;
        if (document.readyState === 'complete') this.onLoad();
        else window.addEventListener('load', this.onLoad, { once: true });
      }
      suppressed() {
        try {
          const saved = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
          return saved && (saved.state === 'subscribed' || Date.now() - saved.time < Number(this.dataset.repeatDays) * 86400000);
        } catch { return false; }
      }
      remember(state) {
        try { localStorage.setItem(this.storageKey, JSON.stringify({ state, time: Date.now() })); } catch {}
      }
      attemptOpen() {
        if (this.suppressed()) return;
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open], #cart-drawer[open], shopify-chat[open]')) {
          this.timer = setTimeout(() => this.attemptOpen(), 1000);
          return;
        }
        this.open();
      }
      open() {
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('load', this.onLoad);
        this.dialog?.removeEventListener('close', this.onClose);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-tools"] && !Shopify.designMode) return;
  try {
    
function initGrowingTools(scope = document) {
  scope.querySelectorAll('[data-growing-tools]').forEach(root => {
    if (root.dataset.toolsReady) return;
    root.dataset.toolsReady = 'true';
    const text = JSON.parse(root.querySelector('[data-tool-text]').textContent);
    const forms = Object.fromEntries(Array.from(root.querySelectorAll('[data-calculator]'), form => [form.dataset.calculator, form]));
    const fmt = (value, digits = 3) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', value > 0 && value < Math.pow(10, -digits) ? { maximumSignificantDigits: 3 } : { maximumFractionDigits: digits }).format(value);
    const number = (form, name) => Number(form.elements.namedItem(name).value);
    const volume = litres => litres >= 1 ? `${fmt(litres)} L` : `${fmt(litres * 1000, 2)} ml`;
    const error = (form, message) => {
      const element = form.querySelector('[data-error]');
      element.textContent = message;
      element.hidden = false;
      form.querySelector('[data-result]').hidden = true;
    };
    const clear = form => {
      form.querySelector('[data-error]').hidden = true;
      form.querySelector('[data-result]').hidden = true;
    };
    const show = form => { form.querySelector('[data-result]').hidden = false; };
    const put = (form, selector, value) => { form.querySelector(selector).textContent = value; };
    const products = Array.from(root.querySelectorAll('[data-mix-product] script'), node => JSON.parse(node.textContent));
    const productSelect = forms.pot.elements.product;
    const bagSelect = forms.pot.elements.bag;
    const bagLitres = title => {
      const match = title.match(/(?:^|[^\d.])(\d+(?:[.,]\d+)?)\s*(ml|l|litres?|liters?)(?=$|\s|\/|[-–])/i);
      if (!match) return null;
      const size = Number(match[1].replace(',', '.')) / (match[2].toLowerCase() === 'ml' ? 1000 : 1);
      return Number.isFinite(size) && size > 0 ? size : null;
    };
    products.forEach((product, index) => {
      productSelect.add(new Option(product.title, product.handle, index === 0, index === 0));
    });
    const currentProduct = () => products.find(product => product.handle === productSelect.value);
    const setProduct = () => {
      const product = currentProduct();
      bagSelect.replaceChildren();
      productSelect.disabled = !product;
      bagSelect.disabled = !product || !product.variants.length;
      forms.pot.querySelector('[data-bag-field]').hidden = bagSelect.disabled;
      forms.pot.querySelector('[data-no-products]').hidden = Boolean(product);
      put(forms.pot, '[data-product-note]', product ? product.note : '');
      if (!product) return;
      const preferred = product.variants.find(variant => variant.available && bagLitres(variant.title)) || product.variants.find(variant => bagLitres(variant.title)) || product.variants[0];
      product.variants.forEach(variant => {
        const status = variant.available ? '' : ` — ${text.sold_out_short}`;
        const selected = variant === preferred;
        bagSelect.add(new Option(`${variant.title} — ${variant.price_text}${status}`, variant.id, selected, selected));
      });
    };
    const updateBags = total => {
      const product = currentProduct();
      const variant = product && product.variants.find(item => item.id === bagSelect.value);
      const size = variant && bagLitres(variant.title);
      forms.pot.querySelector('[data-recommendation]').hidden = !variant;
      forms.pot.querySelector('[data-unknown-volume]').hidden = !variant || Boolean(size);
      if (!variant) return;
      const link = forms.pot.querySelector('[data-buy-link]');
      const base = product.url.split('#')[0];
      link.href = `${base}${base.includes('?') ? '&' : '?'}variant=${encodeURIComponent(variant.id)}${variant.available ? '' : '#RestockRequest'}`;
      link.textContent = variant.available ? text.shop_mix : text.notify_mix;
      put(forms.pot, '[data-stock-note]', variant.available ? text.available : text.unavailable);
      forms.pot.querySelector('.jb-tools__recommendation dl').hidden = !size;
      forms.pot.querySelector('[data-bag-count]').hidden = !size;
      if (!size) return;
      const ratio = total / size;
      const count = Math.max(1, Math.ceil(ratio - Number.EPSILON * Math.max(1, ratio) * 4));
      put(forms.pot, '[data-bag-count]', `${fmt(count, 0)} × ${volume(size)} ${count === 1 ? text.bag_singular : text.bag_plural}`);
      put(forms.pot, '[data-supplied-volume]', volume(count * size));
      put(forms.pot, '[data-spare-volume]', volume(Math.max(0, count * size - total)));
    };
    const mixRows = Array.from(forms.mix.querySelectorAll('[data-ingredient]'));
    const setRecipe = () => {
      const recipe = forms.mix.elements.recipe.value;
      if (recipe === 'custom') return;
      const ingredients = recipe === 'chunky' ? ['ingredient_coir', 'ingredient_bark', 'ingredient_perlite'] : ['ingredient_coir', 'ingredient_grit', 'ingredient_pumice'];
      const parts = recipe === 'chunky' ? [2, 2, 1] : [1, 1, 1];
      mixRows.forEach((row, index) => {
        row.querySelector('[data-name]').value = text[ingredients[index] || 'ingredient_optional'];
        row.querySelector('[data-parts]').value = parts[index] || 0;
      });
      clear(forms.mix);
    };
    const setShape = () => {
      const shape = forms.pot.elements.shape.value;
      forms.pot.querySelectorAll('[data-shape]').forEach(group => {
        const active = group.dataset.shape === shape;
        group.hidden = !active;
        group.querySelectorAll('input').forEach(input => { input.disabled = !active; });
      });
      clear(forms.pot);
    };
    const calculate = form => {
      clear(form);
      if (!form.checkValidity()) {
        error(form, text.number_error);
        form.reportValidity();
        return;
      }
      const type = form.dataset.calculator;
      if (type === 'mix') {
        const items = mixRows.map(row => ({ name: row.querySelector('[data-name]').value.trim(), parts: Number(row.querySelector('[data-parts]').value) })).filter(item => item.parts > 0);
        const parts = items.reduce((total, item) => total + item.parts, 0);
        if (parts === 0) { error(form, text.mix_zero); return; }
        if (items.some(item => !item.name)) { error(form, text.mix_name); return; }
        const litres = number(form, 'batch') / (form.elements.unit.value === 'ml' ? 1000 : 1);
        const body = form.querySelector('[data-mix-rows]');
        body.replaceChildren();
        items.forEach(item => {
          const row = document.createElement('tr');
          [item.name, `${fmt(item.parts / parts * 100, 1)}%`, volume(litres * item.parts / parts)].forEach(value => {
            const cell = document.createElement('td');
            cell.textContent = value;
            row.appendChild(cell);
          });
          body.appendChild(row);
        });
        put(form, '[data-mix-total]', volume(litres));
      } else if (type === 'pot') {
        const shape = form.elements.shape.value;
        const height = number(form, 'height');
        let capacity;
        if (shape === 'rectangle') {
          capacity = number(form, 'length') * number(form, 'width') * height / 1000;
        } else if (shape === 'round') {
          capacity = Math.PI * Math.pow(number(form, 'diameter') / 2, 2) * height / 1000;
        } else {
          const top = number(form, 'top') / 2;
          const bottom = number(form, 'bottom') / 2;
          if (bottom > top) { error(form, text.pot_taper_error); return; }
          capacity = Math.PI * height * (top * top + top * bottom + bottom * bottom) / 3000;
        }
        const media = capacity * number(form, 'fill') / 100;
        const total = media * number(form, 'quantity');
        if (!Number.isFinite(total)) { error(form, text.overflow_error); return; }
        form.dataset.totalLitres = String(total);
        put(form, '[data-capacity]', volume(capacity));
        put(form, '[data-media]', volume(media));
        put(form, '[data-pot-total]', volume(total));
        updateBags(total);
      } else if (type === 'feed') {
        const dose = number(form, 'dose') * number(form, 'strength') / 100;
        put(form, '[data-concentrate]', `${fmt(number(form, 'water') * dose, 3)} ml`);
        put(form, '[data-dose]', fmt(dose));
      } else if (type === 'light') {
        put(form, '[data-dli]', fmt(number(form, 'ppfd') * number(form, 'hours') * 0.0036, 2));
      }
      show(form);
    };
    Object.values(forms).forEach(form => {
      form.addEventListener('submit', event => { event.preventDefault(); calculate(form); });
      form.addEventListener('input', event => {
        clear(form);
        if (form === forms.mix && event.target.closest('[data-ingredient]')) form.elements.recipe.value = 'custom';
        if (form === forms.mix) form.querySelector('[data-transfer]').hidden = true;
      });
      form.addEventListener('reset', () => {
        queueMicrotask(() => {
          clear(form);
          if (form === forms.mix) { setRecipe(); form.querySelector('[data-transfer]').hidden = true; }
          if (form === forms.pot) { setShape(); setProduct(); delete form.dataset.totalLitres; }
        });
      });
    });
    forms.mix.elements.recipe.addEventListener('change', setRecipe);
    forms.pot.elements.shape.addEventListener('change', setShape);
    productSelect.addEventListener('change', () => { setProduct(); calculate(forms.pot); });
    bagSelect.addEventListener('change', () => calculate(forms.pot));
    const diy = root.querySelector('[data-diy-details]');
    root.querySelector('a[href="#tool-mix"]').addEventListener('click', () => { diy.open = true; });
    if (location.hash === '#tool-mix') diy.open = true;
    forms.pot.querySelector('[data-use-mix]').addEventListener('click', () => {
      const litres = Number(forms.pot.dataset.totalLitres);
      if (!Number.isFinite(litres) || litres <= 0) return;
      forms.mix.elements.unit.value = 'L';
      forms.mix.elements.batch.value = String(litres);
      clear(forms.mix);
      const status = forms.mix.querySelector('[data-transfer]');
      status.textContent = text.pot_transfer;
      status.hidden = false;
      diy.open = true;
      root.querySelector('#tool-mix').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      forms.mix.elements.batch.focus({ preventScroll: true });
    });
    setShape();
    setProduct();
    calculate(forms.pot);
    calculate(forms.mix);
  });
}
initGrowingTools();
document.addEventListener('shopify:section:load', event => initGrowingTools(event.target));
document.addEventListener('DOMContentLoaded', () => initGrowingTools());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
